module.exports = __webpack_public_path__ + "static/media/cloud-2.43da4d8b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/cloud-2.svg
// module id = 3366
// module chunks = 6